import React, { useContext, useState } from 'react';
import '../css/topBar.css';
import Block from './block';
import { useSelector } from 'react-redux';
import Icon from '../assets/icons/icon';
import { AgentContext } from '../context/AgentContext';


function TopBar(props) {
    const isFeature971Enabled = process.env.REACT_APP_FUNNEL_FEATURE_971 === 'true'
    const queue = useSelector((state) => state.queue.queue);
    const barState = props.barState;
    const [which, setWhich] = useState('Dashboard');
    const agentInfo = useSelector((state) => state.agent.userData);
    const subscription = useSelector((state) => state.subscription.subscription);
    function fetchPage(path) {
        props.fetchPage(path);
    }
    const hasActiveSubscription = subscription.length > 0 && subscription[0]?.activeSubscription;
    const a2pOnly = !agentInfo.a2pOnly;

    const leads = [
        { "name": "Manage Leads", 'path': 'Add_Leads' },
    ]
    const sync = [
        { "name": "Sync Leads", 'path': 'syncLeads' },
    ]
    const todo = [
        { "name": "Follow-Ups", 'path': 'Follow_Ups' },
        { "name": "Calls", 'path': 'Scheduled_Calls' },
        { "name": "Appointments", 'path': 'Scheduled_Appointments' },
    ]
    const options = [
        { "name": "Subscription", 'path': 'Subscription' }
    ]

    const phone = []

    if ((subscription.length > 0 && subscription[0].activeSubscription) || !agentInfo.a2pOnly) {
        phone.push(
            { "name": "Trust", 'path': 'Trust_Hub' },
            { "name": "Numbers", 'path': 'Number' },
            { "name": "Voicemail", 'path': 'Voicemail' },
            { "name": "Voice Drops", 'path': 'VoiceDrop' },
            { "name": "Forwarding", 'path': 'Call_Forwarding' },
            { "name": "Recording", 'path': 'Call_Recording' }
        );
    }
    else {
        phone.push(
            { "name": "Trust", 'path': 'Trust_Hub' },
            { "name": "Voicemail", 'path': 'Voicemail' },
            { "name": "Recording", 'path': 'Call_Recording' }
        );
    }
    const leadSettings = [
        { "name": "Tags", 'path': 'Tags' },
        { "name": "Types", 'path': 'Lead_Types' }
    ]
    const templates = [];

    if (agentInfo.admin) {
        templates.push(
            { "name": "Text", 'path': 'Text_Templates' },
            { "name": "Email", 'path': 'Email_Templates' },
            { "name": "Script", 'path': 'Scripts' },
            { "name": "Objection", 'path': 'Objections' }
        );
    }else{
        if (agentInfo.organization === 'master') {
            templates.push(
                { "name": "Text", 'path': 'Text_Templates' },
            );
        }else{
            if (agentInfo.permissions.text === 1) {
                templates.push({ "name": "Text", 'path': 'Text_Templates' });
            }
            if (agentInfo.permissions.email === 1) {
                templates.push({ "name": "Email", 'path': 'Email_Templates' });
            }
            if (agentInfo.permissions.script === 1) {
                templates.push({ "name": "Script", 'path': 'Scripts' });
            }
            if (agentInfo.permissions.objection === 1) {
                templates.push({ "name": "Objection", 'path': 'Objections' });
            }
        }
    }

    const dash = [{ "name": "Dashboard", 'path': 'dash' }];
    const team = [{ "name": "Teams", 'path': 'Team' }]
    const market = [{ "name": "Marektplace", 'path': 'Market' }]
    const activity = [{ "name": "Acitivy", 'path': 'Activity' }]
    const workflows = [{ "name": "Workflows", 'path': 'Workflows' }];
    const referrals = []

    const [expanded, setExpanded] = useState(false)
    const handleExpanded = (isExpanded) => {
        if (isFeature971Enabled === true) {
            setExpanded(isExpanded)
        }
    }
    const renderIcon = (icon) => {
        return <span className="fontello"><Icon name={icon} size={20} className="" adjust="fontello" /></span>
    }

    const { isB2B } = useContext(AgentContext)
    return (
        <div className={`${isB2B ? 'b2b ' : ''}leftHandBar`}
            onMouseEnter={() => { handleExpanded(true) }}
            onMouseLeave={() => { handleExpanded(false) }}
        >
            {barState ? (
                <>
                    <Block title="Dashboard" fetchPage={fetchPage} data={dash} icon='dashboard-q' setWhich={setWhich} which={which} />
                    <Block title="Lead Settings" fetchPage={fetchPage} data={leadSettings} icon='q-leads' setWhich={setWhich} which={which} />
                    <Block title="Templates" fetchPage={fetchPage} data={templates} icon='file-chart-q' setWhich={setWhich} which={which} singleBlock={false} />
                    {agentInfo.admin && (
                        <Block title="Workflows" fetchPage={fetchPage} data={workflows} icon='q-dataflow-1' setWhich={setWhich} which={which} />
                    )}
                </>
            ) : (
                <>
                    <Block title="Dashboard" fetchPage={fetchPage} data={dash} icon='dashboard-q' setWhich={setWhich} which={which} />
                    {agentInfo.organization === 'master' && (
                        (subscription.length > 0 && subscription[0].activeSubscription) || !agentInfo.a2pOnly ? (
                            <Block title="Sync Leads" fetchPage={fetchPage} icon='repeat-q' data={sync} setWhich={setWhich} which={which} />
                        ) : (
                            null
                        )
                    )}
                    {(agentInfo.organization !== 'master' && false) && (
                        <Block title="Add Leads" fetchPage={fetchPage} data={leads} icon="q-leads" setWhich={setWhich} which={which} />
                    )}
                    <Block title="To-Dos" fetchPage={fetchPage} data={todo} icon='check-done-01-copy' setWhich={setWhich} which={which} expanded={expanded} singleBlock={false} />
                    <Block title="Team" fetchPage={fetchPage} data={team} icon='q-dataflow-1' setWhich={setWhich} which={which} />
                    {((subscription.length > 0 && subscription[0].activeSubscription) || !agentInfo.a2pOnly) && (
                        <Block title="Activity" fetchPage={fetchPage} data={activity} icon='activity-q' setWhich={setWhich} which={which} />
                    )}

                    <Block title="Phone" fetchPage={fetchPage} data={phone} icon='q-phone-call' setWhich={setWhich} which={which} expanded={expanded} singleBlock={false}/>
                    {(agentInfo.admin) ? (
                        <>
                            <Block title="Templates" fetchPage={fetchPage} data={templates} icon="file-down-q" setWhich={setWhich} which={which} expanded={expanded} singleBlock={false} />
                            <Block title="Workflows" fetchPage={fetchPage} data={workflows} icon="shuffle-q" setWhich={setWhich} which={which} />
                        </>
                    ) : (
                        <>
                            <Block title="Templates" fetchPage={fetchPage} data={templates} icon="file-down-q" setWhich={setWhich} which={which} expanded={expanded} singleBlock={false}/>
                        </>
                    )}
                    {(hasActiveSubscription || a2pOnly) && agentInfo.permissions.lead_market_access === 1 && (
                        <Block title="Market" fetchPage={fetchPage} icon='q-shopping' data={market} setWhich={setWhich} which={which} />
                    )}
                </>
            )}
            {queue.length > 0 && (
                <div id="blockWrapper" className={`${which === 'Resume Session' && 'selectedOption'} resumeSessionBar`}>
                    <div className="blockTitle" onClick={() => props.expandSession()}><span className={`leftBarIconHolder ${which === "Resume Session" && 'adjustIcon'}`}>{renderIcon('q-list')}<span style={{ fontSize: '12px', verticalAlign: "bottom" }}>{queue.length ? queue.length : '?'}</span></span>Resume Session</div>
                    <div className="optionsHolder"></div>
                </div>
            )}
        </div>
    );
}

export default TopBar;
